import React from "react";
import PropTypes from "prop-types";
import Modal from "../../../../parts/modal-new";
import submit from "submit-form";

const PreparingMealPlanModal = ({ locals }) => {
  const handleOkay = () => {
    submit(`/actions/refresh?`, {
      method: "GET",
      body: {
        "modal[type]": "",
      },
    });
  };

  const theme = locals?.activeUser?.webAppTheme || "dark";
  const timerIconSrc = theme === "light" 
    ? "/img/svg/timer-white-theme.svg" 
    : "/img/svg/timer.svg";

  return (
    <Modal
      className="preparing-meal-plan-modal"
      header={false}
      canClose={false}
    >
      <div className="body">
        <div className="preparing-meal-plan-content">
          <div className="timer-icon-container">
            <img
              src={timerIconSrc}
              alt="Timer icon"
              className="timer-icon"
            />
          </div>
          
          <h3 className="preparing-title">
            Preparing Your Meal Plan
          </h3>
          
          <p className="preparing-description">
            This may take up to 5 minutes as we carefully customize<br />
            everything for you. You're free to explore the app—we'll<br />
            notify you once your meal plan is ready.
          </p>
          
          <button
            type="button"
            data-button-type="primary"
            onClick={handleOkay}
            className="okay-button"
          >
            Okay
          </button>
        </div>
      </div>
    </Modal>
  );
};

PreparingMealPlanModal.propTypes = {
  locals: PropTypes.object,
};

export default PreparingMealPlanModal;

